import { RESET_STATE, SET_ICEPACKS_FILLERS, SET_IS_ICEPACKS_FILLERS_LOADING, SET_PAGINATION } from './actions';

export const initialState = {
	icepacksFillers: [],
	isIcepacksFillersLoading: false,
	pagination: null,
};

const icepacksFillersContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACKS_FILLERS:
			return {
				...state,
				icepacksFillers: payload,
			};
		case SET_IS_ICEPACKS_FILLERS_LOADING:
			return {
				...state,
				isIcepacksFillersLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepacksFillersContainerReducer;
